/**
 * 値が数値かどうかを判定する型ガード
 */
export function isNumber(value: unknown): value is number {
  return typeof value === 'number' && !Number.isNaN(value);
}

/**
 * 値が日付かどうかを判定する型ガード
 */
export function isDate(value: unknown): value is Date {
  return value instanceof Date && !Number.isNaN(value.getTime());
}

/**
 * 値がundefinedまたはnullかどうかを判定する型ガード
 */
export function isUndefined(value: unknown): value is undefined | null {
  return value === undefined || value === null;
}
